import { render, staticRenderFns } from "./addDevice.vue?vue&type=template&id=18d50863&scoped=true"
import script from "./addDevice.vue?vue&type=script&lang=js"
export * from "./addDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d50863",
  null
  
)

export default component.exports